import { clsx } from 'clsx';

type TrophyVariant = 'filled' | 'outline' | 'glow';
type TrophySize = 'sm' | 'md' | 'lg';

type TrophyMarkProps = {
  variant?: TrophyVariant;
  size?: TrophySize;
  className?: string;
  ariaLabel?: string;
};

const SIZE_CLASSES: Record<TrophySize, string> = {
  sm: 'w-8 h-8',
  md: 'w-16 h-16',
  lg: 'w-32 h-32',
};

export function TrophyMark({
  variant = 'filled',
  size = 'md',
  className,
  ariaLabel = 'Taça',
}: TrophyMarkProps) {
  const gradientId = `tt-trophy-${variant}-${size}`;

  return (
    <svg
      viewBox="0 0 64 80"
      className={clsx(SIZE_CLASSES[size], className, variant === 'glow' && 'animate-glow-pulse')}
      role="img"
      aria-label={ariaLabel}
      fill="none"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#E8D5A8" />
          <stop offset="0.5" stopColor="#D4AF37" />
          <stop offset="1" stopColor="#8B6F2C" />
        </linearGradient>
      </defs>

      {/* Copa principal */}
      <path
        d="M14 6 H50 V18 C50 32 42 42 36 44 V58 H42 A2 2 0 0 1 42 62 H22 A2 2 0 0 1 22 58 H28 V44 C22 42 14 32 14 18 V6 Z"
        fill={variant === 'outline' ? 'none' : `url(#${gradientId})`}
        stroke={variant === 'outline' ? '#D4AF37' : 'none'}
        strokeWidth={variant === 'outline' ? 1.5 : 0}
      />

      {/* Alças laterais */}
      <path
        d="M14 12 C8 12 4 16 4 22 C4 28 10 30 14 30"
        fill="none"
        stroke={variant === 'outline' ? '#D4AF37' : `url(#${gradientId})`}
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M50 12 C56 12 60 16 60 22 C60 28 54 30 50 30"
        fill="none"
        stroke={variant === 'outline' ? '#D4AF37' : `url(#${gradientId})`}
        strokeWidth={2}
        strokeLinecap="round"
      />

      {/* Base / pedestal */}
      <rect
        x="20"
        y="66"
        width="24"
        height="3"
        rx="1"
        fill={variant === 'outline' ? 'none' : `url(#${gradientId})`}
        stroke={variant === 'outline' ? '#D4AF37' : 'none'}
        strokeWidth={variant === 'outline' ? 1.5 : 0}
      />
      <rect
        x="16"
        y="71"
        width="32"
        height="4"
        rx="1.5"
        fill={variant === 'outline' ? 'none' : `url(#${gradientId})`}
        stroke={variant === 'outline' ? '#D4AF37' : 'none'}
        strokeWidth={variant === 'outline' ? 1.5 : 0}
      />
    </svg>
  );
}
